var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:{ 'v-btn--active': _vm.value },staticStyle:{"border":"none"},attrs:{"icon":_vm.icon},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }